export default __webpack_public_path__ + "static/media/click-and-collect.inline.2c16e342.svg";